/**
 * @generated SignedSource<<72a644c9b18f7555ba260545bd37eaac>>
 * @relayHash 813c4754dfbdd1eab03969d082ad1252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 998aaefdc104460b441f3d1f9aad91dd1e293f198b2699f77ff8c927d5d0b4bb

import type { ConcreteRequest } from 'relay-runtime';
export type EndOfPageRecMenuItemEndOfPageRecHideStatusMutation$variables = {
  id: string;
  status: boolean;
  type: string;
};
export type EndOfPageRecMenuItemEndOfPageRecHideStatusMutation$data = {
  readonly setRecommendedPagesStatus: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type EndOfPageRecMenuItemEndOfPageRecHideStatusMutation = {
  response: EndOfPageRecMenuItemEndOfPageRecHideStatusMutation$data;
  variables: EndOfPageRecMenuItemEndOfPageRecHideStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "enableRecommendedPages",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SetRecommendedPagesStatusPayload",
    "kind": "LinkedField",
    "name": "setRecommendedPagesStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "SetRecommendedPagesStatusPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EndOfPageRecMenuItemEndOfPageRecHideStatusMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndOfPageRecMenuItemEndOfPageRecHideStatusMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "813c4754dfbdd1eab03969d082ad1252",
    "id": "998aaefdc104460b441f3d1f9aad91dd1e293f198b2699f77ff8c927d5d0b4bb",
    "metadata": {},
    "name": "EndOfPageRecMenuItemEndOfPageRecHideStatusMutation",
    "operationKind": "mutation",
    "text": "mutation EndOfPageRecMenuItemEndOfPageRecHideStatusMutation($type:String!,$id:ID!,$status:Boolean!){setRecommendedPagesStatus(input:{entityType:$type,entityId:$id,enableRecommendedPages:$status}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "4cb61598ff107450de867b71f94e866c";

export default node;
